<template>
    <div class="h-100">
        <div class="row">
            <div class="col-xs-12 form-inline">
                <div class="form-group">
                    <label for="filter" class="sr-only">Filter</label>
                    <input id="filter" type="text" class="form-control" v-model="filter" placeholder="Filter">
                </div>
            </div>
        </div>
        <div class="row">
            <div id="table" class="col-xs-12 table-responsive">
                <datatable
                    :columns="columns"
                    :data="items"
                    :filter="filter"
                ></datatable>
            </div>
        </div>
        <div class="row" v-if="showPagination">
            <div class="col-xs-12 form-inline">
                <datatable-pager v-model="page" type="abbreviated" :per-page="perPage"></datatable-pager>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      filter: null,
      page: 1
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    showPagination: {
      default: true,
      type: Boolean,
      required: false
    },
    perPage: {
      default: 20,
      type: Number,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datatable/Base.vue